import { Component } from "@angular/core";

@Component({
	selector: 'content-container',
	styleUrls: ['content-container.css'],
	templateUrl: 'content-container.html',
})
export class ContentContainerComponent{
}
